/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CommentDto } from '../model';
// @ts-ignore
import type { CreateCommentDto } from '../model';
// @ts-ignore
import type { PaginatedCommentLikersResponseDto } from '../model';
// @ts-ignore
import type { PaginatedCommentsResponseDto } from '../model';
// @ts-ignore
import type { ToggleCommentLikeResponseDto } from '../model';
// @ts-ignore
import type { UpdateCommentDto } from '../model';
/**
 * CommentsApi - axios parameter creator
 * @export
 */
export const CommentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new comment
         * @param {CreateCommentDto} createCommentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsControllerCreate: async (createCommentDto: CreateCommentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCommentDto' is not null or undefined
            assertParamExists('commentsControllerCreate', 'createCommentDto', createCommentDto)
            const localVarPath = `/api/comments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCommentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a comment (soft delete)
         * @param {string} id Comment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsControllerDeleteComment: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('commentsControllerDeleteComment', 'id', id)
            const localVarPath = `/api/comments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get comments by user ID
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsControllerFindByUser: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('commentsControllerFindByUser', 'userId', userId)
            const localVarPath = `/api/comments/user/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a single comment by ID
         * @param {string} id Comment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsControllerFindOne: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('commentsControllerFindOne', 'id', id)
            const localVarPath = `/api/comments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get users who liked a comment with pagination
         * @param {string} id Comment ID
         * @param {number} [page] Page number (starts from 1)
         * @param {number} [limit] Number of users per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsControllerGetCommentLikers: async (id: string, page?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('commentsControllerGetCommentLikers', 'id', id)
            const localVarPath = `/api/comments/{id}/likers`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get comments by post ID with pagination
         * @param {string} postId Post ID
         * @param {number} [page] Page number (starts from 1)
         * @param {number} [limit] Number of comments per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsControllerGetCommentsByPostIdPaginated: async (postId: string, page?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postId' is not null or undefined
            assertParamExists('commentsControllerGetCommentsByPostIdPaginated', 'postId', postId)
            const localVarPath = `/api/comments/post/{postId}`
                .replace(`{${"postId"}}`, encodeURIComponent(String(postId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get replies to a comment with pagination
         * @param {string} parentCommentId Parent comment ID
         * @param {number} [page] Page number (starts from 1)
         * @param {number} [limit] Number of replies per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsControllerGetRepliesPaginated: async (parentCommentId: string, page?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'parentCommentId' is not null or undefined
            assertParamExists('commentsControllerGetRepliesPaginated', 'parentCommentId', parentCommentId)
            const localVarPath = `/api/comments/replies/{parentCommentId}`
                .replace(`{${"parentCommentId"}}`, encodeURIComponent(String(parentCommentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Toggle like on a comment
         * @param {string} id Comment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsControllerToggleCommentLike: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('commentsControllerToggleCommentLike', 'id', id)
            const localVarPath = `/api/comments/{id}/like`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a comment
         * @param {string} id Comment ID
         * @param {UpdateCommentDto} updateCommentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsControllerUpdateComment: async (id: string, updateCommentDto: UpdateCommentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('commentsControllerUpdateComment', 'id', id)
            // verify required parameter 'updateCommentDto' is not null or undefined
            assertParamExists('commentsControllerUpdateComment', 'updateCommentDto', updateCommentDto)
            const localVarPath = `/api/comments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCommentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommentsApi - functional programming interface
 * @export
 */
export const CommentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new comment
         * @param {CreateCommentDto} createCommentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commentsControllerCreate(createCommentDto: CreateCommentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commentsControllerCreate(createCommentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentsApi.commentsControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a comment (soft delete)
         * @param {string} id Comment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commentsControllerDeleteComment(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commentsControllerDeleteComment(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentsApi.commentsControllerDeleteComment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get comments by user ID
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commentsControllerFindByUser(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commentsControllerFindByUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentsApi.commentsControllerFindByUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a single comment by ID
         * @param {string} id Comment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commentsControllerFindOne(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commentsControllerFindOne(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentsApi.commentsControllerFindOne']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get users who liked a comment with pagination
         * @param {string} id Comment ID
         * @param {number} [page] Page number (starts from 1)
         * @param {number} [limit] Number of users per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commentsControllerGetCommentLikers(id: string, page?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedCommentLikersResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commentsControllerGetCommentLikers(id, page, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentsApi.commentsControllerGetCommentLikers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get comments by post ID with pagination
         * @param {string} postId Post ID
         * @param {number} [page] Page number (starts from 1)
         * @param {number} [limit] Number of comments per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commentsControllerGetCommentsByPostIdPaginated(postId: string, page?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedCommentsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commentsControllerGetCommentsByPostIdPaginated(postId, page, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentsApi.commentsControllerGetCommentsByPostIdPaginated']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get replies to a comment with pagination
         * @param {string} parentCommentId Parent comment ID
         * @param {number} [page] Page number (starts from 1)
         * @param {number} [limit] Number of replies per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commentsControllerGetRepliesPaginated(parentCommentId: string, page?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedCommentsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commentsControllerGetRepliesPaginated(parentCommentId, page, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentsApi.commentsControllerGetRepliesPaginated']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Toggle like on a comment
         * @param {string} id Comment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commentsControllerToggleCommentLike(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ToggleCommentLikeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commentsControllerToggleCommentLike(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentsApi.commentsControllerToggleCommentLike']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a comment
         * @param {string} id Comment ID
         * @param {UpdateCommentDto} updateCommentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commentsControllerUpdateComment(id: string, updateCommentDto: UpdateCommentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commentsControllerUpdateComment(id, updateCommentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentsApi.commentsControllerUpdateComment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CommentsApi - factory interface
 * @export
 */
export const CommentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommentsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new comment
         * @param {CreateCommentDto} createCommentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsControllerCreate(createCommentDto: CreateCommentDto, options?: RawAxiosRequestConfig): AxiosPromise<CommentDto> {
            return localVarFp.commentsControllerCreate(createCommentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a comment (soft delete)
         * @param {string} id Comment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsControllerDeleteComment(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.commentsControllerDeleteComment(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get comments by user ID
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsControllerFindByUser(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<CommentDto> {
            return localVarFp.commentsControllerFindByUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a single comment by ID
         * @param {string} id Comment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsControllerFindOne(id: string, options?: RawAxiosRequestConfig): AxiosPromise<CommentDto> {
            return localVarFp.commentsControllerFindOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get users who liked a comment with pagination
         * @param {string} id Comment ID
         * @param {number} [page] Page number (starts from 1)
         * @param {number} [limit] Number of users per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsControllerGetCommentLikers(id: string, page?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedCommentLikersResponseDto> {
            return localVarFp.commentsControllerGetCommentLikers(id, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get comments by post ID with pagination
         * @param {string} postId Post ID
         * @param {number} [page] Page number (starts from 1)
         * @param {number} [limit] Number of comments per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsControllerGetCommentsByPostIdPaginated(postId: string, page?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedCommentsResponseDto> {
            return localVarFp.commentsControllerGetCommentsByPostIdPaginated(postId, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get replies to a comment with pagination
         * @param {string} parentCommentId Parent comment ID
         * @param {number} [page] Page number (starts from 1)
         * @param {number} [limit] Number of replies per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsControllerGetRepliesPaginated(parentCommentId: string, page?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedCommentsResponseDto> {
            return localVarFp.commentsControllerGetRepliesPaginated(parentCommentId, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Toggle like on a comment
         * @param {string} id Comment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsControllerToggleCommentLike(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ToggleCommentLikeResponseDto> {
            return localVarFp.commentsControllerToggleCommentLike(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a comment
         * @param {string} id Comment ID
         * @param {UpdateCommentDto} updateCommentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsControllerUpdateComment(id: string, updateCommentDto: UpdateCommentDto, options?: RawAxiosRequestConfig): AxiosPromise<CommentDto> {
            return localVarFp.commentsControllerUpdateComment(id, updateCommentDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CommentsApi - object-oriented interface
 * @export
 * @class CommentsApi
 * @extends {BaseAPI}
 */
export class CommentsApi extends BaseAPI {
    /**
     * 
     * @summary Create a new comment
     * @param {CreateCommentDto} createCommentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApi
     */
    public commentsControllerCreate(createCommentDto: CreateCommentDto, options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).commentsControllerCreate(createCommentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a comment (soft delete)
     * @param {string} id Comment ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApi
     */
    public commentsControllerDeleteComment(id: string, options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).commentsControllerDeleteComment(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get comments by user ID
     * @param {string} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApi
     */
    public commentsControllerFindByUser(userId: string, options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).commentsControllerFindByUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a single comment by ID
     * @param {string} id Comment ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApi
     */
    public commentsControllerFindOne(id: string, options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).commentsControllerFindOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get users who liked a comment with pagination
     * @param {string} id Comment ID
     * @param {number} [page] Page number (starts from 1)
     * @param {number} [limit] Number of users per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApi
     */
    public commentsControllerGetCommentLikers(id: string, page?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).commentsControllerGetCommentLikers(id, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get comments by post ID with pagination
     * @param {string} postId Post ID
     * @param {number} [page] Page number (starts from 1)
     * @param {number} [limit] Number of comments per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApi
     */
    public commentsControllerGetCommentsByPostIdPaginated(postId: string, page?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).commentsControllerGetCommentsByPostIdPaginated(postId, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get replies to a comment with pagination
     * @param {string} parentCommentId Parent comment ID
     * @param {number} [page] Page number (starts from 1)
     * @param {number} [limit] Number of replies per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApi
     */
    public commentsControllerGetRepliesPaginated(parentCommentId: string, page?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).commentsControllerGetRepliesPaginated(parentCommentId, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Toggle like on a comment
     * @param {string} id Comment ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApi
     */
    public commentsControllerToggleCommentLike(id: string, options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).commentsControllerToggleCommentLike(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a comment
     * @param {string} id Comment ID
     * @param {UpdateCommentDto} updateCommentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApi
     */
    public commentsControllerUpdateComment(id: string, updateCommentDto: UpdateCommentDto, options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).commentsControllerUpdateComment(id, updateCommentDto, options).then((request) => request(this.axios, this.basePath));
    }
}

